import 'css-chunksrc/client/pages/zonePage/reportsPage/styles.scss';export default {
  "reportsPage": "_reportsPage_17w6e_1",
  "main": "_main_17w6e_7",
  "sections": "_sections_17w6e_16",
  "reversedSections": "_reversedSections_17w6e_27",
  "section": "_section_17w6e_16",
  "title": "_title_17w6e_39",
  "reportsList": "_reportsList_17w6e_45",
  "report": "_report_17w6e_1"
};